import { defineMessages } from 'react-intl';

const messages = defineMessages({
  registrationFailure: {
    description: 'Seller Fulfillment provider registration failure',
    defaultMessage:
      'We were unable to register your fulfillment provider. Please try again. If this issue persists, please reach out to our support team.',
    id: 'iqM+D5',
  },
  fatalError: {
    description: 'Seller Fulfillment provider registration failure',
    defaultMessage:
      "We've encountered an issue working with your fulfillment provider. If this issue persists, please reach out to our support team.",
    id: 'ZdQmYv',
  },
  fulfillmentServicesLoadErrorTitle: {
    description: 'Title for Error Pop Up when Vendors failed to load.',
    defaultMessage: 'Failed to Load',
    id: 'adD2uq',
  },
  fulfillmentServicesLoadErrorContent: {
    description: 'Content for Error Pop Up when Vendors failed to load.',
    defaultMessage: 'An unexpected error occurred while loading fulfillment services.',
    id: 'o9D56X',
  },
  fulfillmentServices: {
    description: 'Fulfillment Provider page section subtitle',
    defaultMessage: 'Fulfillment Services',
    id: 'MhTssN',
  },
  fulfillmentProviders: {
    description: 'Fulfillment Provider page section subtitle',
    defaultMessage: 'Fulfillment Providers',
    id: 'BKd47/',
  },
  addAProvider: {
    description: 'Fulfillment Provider Add button',
    defaultMessage: 'Add a Provider',
    id: 'IkAbz5',
  },
  addAProviderAccount: {
    description: 'Fulfillment Provider Add button',
    defaultMessage: 'Add a Provider Account',
    id: 'efBS2O',
  },
});

export default messages;
